export function getVariable(variables, search) {
    let variable = variables.find((variable) => variable.attribute === search);
    return variable.type === 'number' ? variable.value : variable.content;
}
